import axios from '../../bootstrap';

/**
 * @param {any} odjData
 */
export function axiosSaveForm(odjData) {
    return axios.post('/api/admin/form/saveformdata', odjData);
}
